import { defineMessages } from 'react-intl';

export default defineMessages({
  chargeAfterLogoAlt: {
    id: 'SteppedPaymentForm.chargeAfterLogo.alt',
    description: 'Alternative text to ChargeAfter logo',
    defaultMessage: 'ChargeAfter',
  },
  affirmLogoAlt: {
    id: 'SteppedPaymentForm.affirmLogo.alt',
    description: 'Alternative text to Affitm logo',
    defaultMessage: 'Affirm',
  },
  affirmLegend: {
    id: 'SteppedPaymentForm.affirm.legend',
    description: 'Legend for Affirm rowz',
    defaultMessage: 'As low as 0% APR with monthly payments',
  },
  affirmAsLowAsLegend: {
    id: 'SteppedPaymentForm.affirm.affirmAsLowAsLegend',
    description: 'Legend for Affirm as low as legend',
    defaultMessage: 'as low as',
  },
  acimaLogoAlt: {
    id: 'SteppedPaymentForm.acimaLogo.alt',
    description: 'Alternative text to Affitm logo',
    defaultMessage: 'Acima',
  },
  acimaLegend: {
    id: 'SteppedPaymentForm.acima.legend',
    description: 'Legend for Acima row',
    defaultMessage: 'The no credit option',
  },
  chargeAfterLegend: {
    id: 'SteppedPaymentForm.chargeAfter.legend',
    description: 'Legend for CharteAfter row',
    defaultMessage: '0% APR with 36-month financing',
  },
  purpleFinancingTitle: {
    id: 'SteppedPaymentForm.purpleFinancingTitle',
    description: 'Title for Purple Financing logo',
    defaultMessage: 'Purple Financing',
  },
  payWithPurpleCreditCardTitle: {
    id: 'SteppedPaymentForm.payWithPurpleCreditCardTitle',
    description: 'Title for Pay With Purple Credit Card logo',
    defaultMessage: 'Pay With Purple Credit Card',
  },
  amazonPayLogoAlt: {
    id: 'SteppedPaymentForm.amazonPay.alt',
    description: 'Alternative text to AmazonPay logo',
    defaultMessage: 'AmazonPay',
  },
  applePayLogoAlt: {
    id: 'SteppedPaymentForm.applePay.alt',
    description: 'Alternative text to ApplePay logo',
    defaultMessage: 'Apple Pay',
  },
  shopPayLogoAlt: {
    id: 'SteppedPaymentForm.shopPay.alt',
    description: 'Alternative text to ShopPay logo',
    defaultMessage: 'Shop Pay',
  },
  applePayId: {
    id: 'SteppedPaymentForm.applePay.id',
    description: 'Apple Pay id',
    defaultMessage: 'apple-pay-btn',
  },
  creditCardRowTitle: {
    id: 'SteppedPaymentForm.CreditCardRow.title',
    description: 'Credit Card Row Title',
    defaultMessage: 'Credit Card',
  },
  creditCardLogoAlt: {
    id: 'SteppedPaymentForm.CreditCardRow.logo.alt',
    description: 'Credit Card Row logo image alt',
    defaultMessage: 'Credit Card',
  },
  learnMore: {
    id: 'SteppedPaymentForm.LearnMore',
    description: 'Learn More legend',
    defaultMessage: 'Learn More',
  },
  payPalLogoAlt: {
    id: 'SteppedPaymentForm.payPal.alt',
    description: 'Alternative text to PayPal logo',
    defaultMessage: 'PayPal',
  },
  splitItLogoAlt: {
    id: 'SteppedPaymentForm.splitItLogo.alt',
    description: 'Alternative text to SplitIt logo',
    defaultMessage: 'SplitIt',
  },
  splitItLegend: {
    id: 'SteppedPaymentForm.splitIt.legend',
    description: 'Legend for splitIt rowz',
    defaultMessage: 'Monthly payments using your credit card at 0% interest.',
  },
  title: {
    id: 'SteppedPaymentForm.PaymentForm.title',
    description: 'Payment Form Title',
    defaultMessage: 'Payment Info',
  },
  affirmNotAvailable: {
    id: 'SteppedPaymentForm.affirmNotAvailable.message',
    description:
      'Text when there are non leasable items in the cart and Affirm cannot be used',
    defaultMessage:
      'Affirm cannot be applied due to donations added to your cart. Please remove donations if you wish to complete your purchase with Affirm.',
  },
  chargeAfterNotAvailable: {
    id: 'SteppedPaymentForm.chargeAfterNotAvailable.message',
    description:
      'Text when there are non leasable items in the cart and ChargeAfter cannot be used',
    defaultMessage:
      'ChargeAfter cannot be applied due to donations added to your cart. Please remove donations if you wish to complete your purchase with Affirm.',
  },
  affirmAdvice: {
    id: 'SteppedPaymentForm.affirmAdvice.message',
    defaultMessage:
      'You will be redirected to Affirm to complete your order on the next step.',
  },
  chargeAfterPendingWidget: {
    id: 'SteppedPaymentForm.chargeAfterPendingWidget',
    defaultMessage: 'Pending widget',
  },
  chargeAfterHeadline0APR60Months: {
    id: 'SteppedPaymentForm.chargeAfterHeadline0APR60Months',
    description: 'Headline text for 0APR60Months',
    defaultMessage: '0% APR for 60 months',
  },
  chargeAfterHeadline0APR48Months: {
    id: 'SteppedPaymentForm.chargeAfterHeadline0APR48Months',
    description: 'Headline text for 0APR48Months',
    defaultMessage: '0% APR for 48 months',
  },
  chargeAfterHeadline0APR36Months: {
    id: 'SteppedPaymentForm.chargeAfterHeadline0APR36Months',
    description: 'Headline text for 0APR36Months',
    defaultMessage: '0% APR for 36 months',
  },

  chargeAfterHeadline0APR24Months: {
    id: 'SteppedPaymentForm.chargeAfterHeadline0APR24Months',
    description: 'Headline text for 0APR24Months',
    defaultMessage: '0% APR for 24 months',
  },
  chargeAfterHeadlinePayAtYourOwnPace: {
    id: 'SteppedPaymentForm.chargeAfterHeadlinePayAtYourOwnPace',
    description: 'Headline text for PayAtYourOwnPace',
    defaultMessage: 'Pay at your own pace',
  },
  chargeAfterHeadlineBuyNowPayOverTime: {
    id: 'SteppedPaymentForm.chargeAfterHeadlineBuyNowPayOverTime',
    description: 'Headline text for BuyNowPayOverTime',
    defaultMessage: 'Buy now, pay over time',
  },
  cardNameInfo: {
    id: 'SteppedPaymentForm.PaymentForm.info',
    description: 'List of credit card names',
    defaultMessage: 'Visa, Mastercard, Amex, JCB, Discover',
  },
  confirmButton: {
    id: 'SteppedPaymentForm.PaymentForm.confirm.title',
    defaultMessage: 'Add Credit Card',
  },
  confirmButtonStripe: {
    id: 'SteppedPaymentForm.PaymentForm.confirm.button',
    defaultMessage: 'Add Payment Method',
  },
  cancelButtonLabel: {
    id: 'SteppedPaymentForm.PaymentForm.cancelButton.title',
    defaultMessage: 'Cancel',
  },
  affirmLegendWithPrice: {
    id: 'SteppedPaymentForm.affirmLegendWithPrice',
    defaultMessage: 'As low as {price} at 0% APR up to 36 months',
  },
  truemedAltText: {
    id: 'SteppedPaymentForm.truemedAltText',
    description: 'Alt text for Truemed button',
    defaultMessage: 'Truemed Icon',
  },
  truemedPaymentText: {
    id: 'SteppedPaymentForm.truemedPaymentText',
    description: 'Truemed payment text',
    defaultMessage: 'Pay with HSA/FSA',
  },
  customPaymentMethodContinueWith: {
    id: 'SteppedPaymentForm.customPaymentMethodContinueWith',
    description:
      'Text for continue with {paymentMethod} button on custom payment methods',
    defaultMessage: 'Continue with {paymentMethod}',
  },
  billingAddressCTAText: {
    id: 'SteppedPaymentForm.billingAddressCTAText',
    description: 'CTA text for billing address form',
    defaultMessage: 'Save',
  },
  customPaymentMethodChangeTo: {
    id: 'SteppedPaymentForm.customPaymentMethodChangeTo',
    description:
      'Text for change to {paymentMethod} button on custom payment methods',
    defaultMessage: 'Change to {paymentMethod}',
  },
  creditCardRowPaymentLabel: {
    id: 'SteppedPaymentForm.creditCardRowPaymentLabel',
    description: 'Label for credit card payment row',
    defaultMessage: 'Credit Card',
  },
  truemedPaymentLabel: {
    id: 'SteppedPaymentForm.truemedPaymentLabel',
    description: 'Label for Truemed payment method',
    defaultMessage: 'Truemed',
  },
  acimaPaymentLabel: {
    id: 'SteppedPaymentForm.acimaPaymentLabel',
    description: 'Label for Acima payment method',
    defaultMessage: 'Acima',
  },
  chargeAfterPaymentLabel: {
    id: 'SteppedPaymentForm.chargeAfterPaymentLabel',
    description: 'Label for Charge After payment method',
    defaultMessage: 'ChargeAfter',
  },
  shopPayPaymentLabel: {
    id: 'SteppedPaymentForm.shopPayPaymentLabel',
    description: 'Label for Shop Pay payment method',
    defaultMessage: 'Shop Pay',
  },
  amazonPayPaymentLabel: {
    id: 'SteppedPaymentForm.amazonPayPaymentLabel',
    description: 'Label for Amazon Pay payment method',
    defaultMessage: 'Amazon Pay',
  },
  linkPaymentLabel: {
    id: 'SteppedPaymentForm.linkPaymentLabel',
    description: 'Label for Link payment method',
    defaultMessage: 'Link',
  },
  creditCardPaymentLabel: {
    id: 'SteppedPaymentForm.creditCardPaymentLabel',
    description: 'Label for Credit Card payment method',
    defaultMessage: 'Credit Card',
  },
  affirmPaymentLabel: {
    id: 'SteppedPaymentForm.affirmPaymentLabel',
    description: 'Label for Affirm payment method',
    defaultMessage: 'Affirm',
  },
  klarnaPaymentLabel: {
    id: 'SteppedPaymentForm.klarnaPaymentLabel',
    description: 'Label for Klarna payment method',
    defaultMessage: 'Klarna',
  },
  afterpayPaymentLabel: {
    id: 'SteppedPaymentForm.afterpayPaymentLabel',
    description: 'Label for Afterpay payment method',
    defaultMessage: 'Afterpay',
  },
  defaultPaymentLabel: {
    id: 'SteppedPaymentForm.defaultPaymentLabel',
    description: 'Label for default payment method',
    defaultMessage: 'update',
  },
  defaultEditLabel: {
    id: 'SteppedPaymentForm.defaultEditLabel',
    description: 'Label for default edit action',
    defaultMessage: 'Update',
  }
});
